module.exports = __webpack_public_path__ + "img/openbank-dark.1948b33f.png";